import setPlayerKey from './set_player_key';

export default {
  setPlayerKey,
};
